import { render, staticRenderFns } from "./PrivacyPolicyInfo.vue?vue&type=template&id=375997de&scoped=true&"
import script from "./PrivacyPolicyInfo.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyInfo.vue?vue&type=style&index=0&id=375997de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375997de",
  null
  
)

export default component.exports